const _version = "3.2.4"
function version() {
    return _version
}
export default version
